<template>
    <b-row v-if="row.status === 'Working'">
        <div class="OTloading">
            <div class="OTloadersmall"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'Error'">
        <div class="OTloading">
            <div class="ot-icon-err-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'Running'">
        <div class="OTloading">
            <div class="ot-icon-dashboard-statusonline"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'NotRunning'">
        <div class="OTloading">
            <div class="ot-icon-dashboard-offline"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'CommunicationError'">
        <div class="OTloading">
            <div class="ot-icon-dashboard-communication"></div>
        </div>
    </b-row>
</template>

<script>

export default {
    props: ['row'],
}

</script>